export enum GTMEventNames {
  IS_AMC_TRANSACTION_SUCCESS = 'Is_AMC_TransactionSuccess',
  BUY_AMC_CONFIRMATION_SCREEN_LANDED = 'Buy AMC Confirmation Screen Landed',
  SERVICE_REQ_SUBMITTED = 'ServiceReq_Submitted',
  // New
  LOGGEDIN_DEVICE_HOMEPAGE_LANDED = 'LoggedIn_Device_Homepage_Landed',
  GET_AMC_CLICKED = 'Get_AMC_Clicked',
  RENEW_AMC_CLICKED = 'Renew_AMC_Clicked',
  BOOK_SERVICE_CLICKED = 'Book_Service_Clicked',
  RENEW_RENTAL_CLICKED = 'Renew_Rental_Clicked',
  SERVICE_TYPE_SELECTION_SCREEN_LANDED = 'ServiceTypeSelectionScreen_Landed',
  LEAD_SUBMITTED = 'Book_A_Demo_Lead_Submitted',
  ENQUIRY_LEAD_SUBMITTED = 'Product_Enquiry_Lead_Submitted',
  BOOK_DEMO_PAGE_VIEWED = 'Book_A_Demo_Viewed',
  BOOK_A_SLOT_SCREEN_LANDED = 'Book_A_Slot_Screen_Landed',
  BOOK_A_SLOT_SCREEN_DATE_SELECTED = 'Book_A_Slot_Screen_Date_Selected',
  BOOK_A_SLOT_SCREEN_TIME_SELECTED = 'Book_A_Slot_Screen_Time_Selected',
  BOOK_A_SLOT_SCREEN_CONTINUE_CLICKED = 'Book_A_Slot_Screen_Continue_Clicked',
  BOOK_A_SLOT_SCREEN_DEVICE_PICKER_SELECTED = 'Book_A_Slot_Screen_Device_Picker_Selected',
  BOOK_A_SLOT_SCREEN_BACK_CLICKED = 'Book_A_Slot_Screen_Back_Clicked',
  AMC_UPSELL_SCREEN_LANDED = 'AMC_Upsell_Screen_Landed',
  AMC_UPSELL_SCREEN_BACK_CLICKED = 'AMC_Upsell_Screen_Back_Clicked',
  PURCHASE_AMC_SCREEN_LANDED = 'Purchase_AMC_Screen_Landed',
  PURCHASE_AMC_SCREEN_BACK_CLICKED = 'Purchase_AMC_Screen_Back_Clicked',
  AMC_PAYMENT_SUMMARY_LANDED = 'AMC_Payment_Summary_Landed',
  AMC_PAYMENT_SUMMARY_COUPON_BUTTON_CLICKED = 'AMC_Payment_Summary_Coupon_Button_Clicked',
  AMC_PAYMENT_SUMMARY_COUPON_APPLIED = 'AMC_Payment_Summary_Coupon_Applied',
  AMC_PAYMENT_SUMMARY_TECHNICIAN_CODE_ENTERED = 'AMC_Payment_Summary_Technician_Code_Entered',
  AMC_PAYMENT_SUMMARY_TNC_SELECTED = 'AMC_Payment_Summary_Tnc_Selected',
  AMC_PAYMENT_SUMMARY_TNC_DESELECTED = 'AMC_Payment_Summary_Tnc_deselected',
  AMC_PAYMENT_SUMMARY_PAY_BUTTON_CLICKED = 'AMC_Payment_Summary_Pay_Button_Clicked',
  AMC_PAYMENT_SUMMARY_BACK_CLICKED = 'AMC_Payment_Summary_Back_Clicked',
  AMC_PAYMENT_SCREEN_BOOK_SERVICE_CLICKED = 'AMC_Payment_Screen_Book_Service_Clicked',
  SERVICE_BOOKING_SUCCESS_UPSELL_LANDED = 'Service_Booking_Success_Upsell_Landed',
  SERVICE_BOOKING_SUCCESS_LANDED = 'Service_Booking_Success_Landed',
  SERVICE_BOOKING_BLOCKED_FROM_WEB = 'Service_booking_blocked_from_web',
  SERVICE_ISSUE_TYPE_SELECTED = 'ServiceIssueType_Selected',
  SERVICE_ISSUE_TYPE_CONTINUE_CLICKED = 'ServiceIssueType_Continue_Clicked',
  SERVICE_SCREEN_BACK_CLICKED = 'ServiceScreen_Back_Clicked',
  SERVICE_SCREEN_DEVICE_CHANGED = 'ServiceScreen_DeviceChanged',
  WEB_SERVICE_PAGE_LANDING = 'Web_Service_Page_Landing',
  PURCHASE = 'purchase',
  AMC_PAYMENT_STATUS = 'AMC_Payment_Status',
  IS_UNASSISTED_AMC_TRANSACTION_SUCCESS = 'Is_Unassisted_AMC_TransactionSuccess',
  DEVICE_DETAIL_PAGE = 'Device_Detail_Page',
  // Login
  LOGIN_SCREEN_LANDED = 'LoginScreen_Landed',
  GET_OTP_CLICKED = 'GetOTP_Clicked',
  MOBILE_NUMBER_FOCUSED = 'MobileNumber_Focused',
  MOBILE_NUMBER_TYPING_STARTED = 'MobileNumber_Typing_Started',
  MOBILE_NUMBER_TYPING_COMPLETED = 'MobileNumber_Typing_Completed',
  LOGIN_SCREEN_BACK_CLICKED = 'LoginScreen_Back_Clicked',
  TSA_APP_INSTALLED = 'TSA_App_Installed',
  // OTP
  OTP_SCREEN_LANDED = 'OTPScreen_Landed',
  OTP_SCREEN_BACK_CLICKED = 'OTPScreen_Back_Clicked',
  OTP_RESEND = 'OTP_Resend',
  OTP_VERIFIED = 'OTP_Verified',
  IMAGETHUMBNAIL_CLICKED = 'ImageThumbnail_Clicked',
  IMAGECLICKED = 'ImageClicked',
  IMAGEGALLERY_OPENED = 'ImageGallery_Opened',

  //PREPAID SERVICE BOOKING JOURNEY
  PREPAID_CHECKOUT_SCREEN_LANDED = 'Prepaid_Service_Checkout_Screen_Landed',
  PREPAID_CHECKOUT_BUTTON_CLICKED = 'Prepaid_Service_ Checkout_Button_Clicked',
  PREPAID_SUCCESS_SCREEN_LANDED = 'Prepaid_Service_Success_Screen_Landed',
}

export enum SCREEN_NAMES {
  DEVICE_HOMEPAGE = 'Device Homepage',
  SERVICE_TYPE_SELECTION = 'Service type selection',
  BOOK_A_SLOT = 'Book a slot',
  AMC_UPSELL = 'AMC upsell',
  PURCHASE_AMC = 'Purchase AMC',
  AMC_PAYMENT_SUMMARY = 'AMC Payment Summary',
  SERVICE_BOOKING_SUCCESS = 'Service Book Success',
  LOGIN_FORM = 'Login Form',
  LOGIN_OTP = 'Login OTP',
  PRODUCT_DETAILS = 'Product Details',
  BOOK_DEMO_PAGE = 'Book A Demo Page',
  PRODUCT_ENQUIRY = 'Product Enquiry Page',
  DEVICE_DETAIL = 'Device Detail',
}

export enum GTMPageNames {
  AMC_THANKYOU_PAGE = 'AMC Thankyou Page',
  SERVICE_THANKYOU_PAGE = 'Service Thankyou Page',
}

export interface GTMCommonEventData {
  event?: GTMEventNames;
  pageName?: GTMPageNames;
  loginStatus?: boolean | string;
  siteSection?: string;
  supportCategory?: string;
  customerId?: string;
  mid?: string;
  eid?: string;
  userPincode?: string;
  Usercity?: string;
  GAcookie_id?: string;
  navigated_from?: string;
  buttonName?: string;
}

export interface GTMPageSpecificEventData {
  amcProductName?: string;
  amcPlan?: any;
  amc_plan_value?: any;
  couponCode?: string;
  AMCEndDate?: string;
  paymentMode?: string;
  technicianAssistance?: 'yes' | 'no';
  technicianCode?: string;
  serviceProductName?: string;
  serviceCategory?: 'Repair' | 'Uninstall' | 'Reinstall';
  serviceType?: string;
  serviceDate?: string;
  serviceTime?: string;
  isFMS?: boolean;
}

export interface GTMEventData extends GTMCommonEventData, Partial<GTMPageSpecificEventData> {}

export interface GTMDataLayer {
  push: (data: GTMEventData) => void;
}
